


export const FileUploadType = {
    POST: 'post',
    PROFILE: 'profile',
    FILE_UPLOAD: 'file_upload'
}